import React from "react"
import styles from "./styles.scss"
import cx from "classnames"

class CurveWrapper extends React.Component {
  render() {
    const { direction, children, backgroundColor } = this.props

    return (
      <div className={styles.container}>
        <div
          style={{ backgroundColor }}
          className={cx(styles.curve, {
            [styles.up]: direction === "up",
            [styles.down]: direction === "down",
          })}
        >
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    )
  }
}

CurveWrapper.defaultProps = {
  direction: "down",
  backgroundColor: "#fafafa",
}

export default CurveWrapper



// WEBPACK FOOTER //
// ./src/components/CurveWrapper/index.jsx